module.exports = __webpack_public_path__ + "static/media/emv_large.d19dce48.jpeg";